import type React from 'react';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteRounded from '@mui/icons-material/DeleteRounded';
import { Button, DialogActions } from '@mui/material';

import ButtonPanel from 'src/components/common/ButtonPanel';
import Modal from 'src/components/common/Modal';
import { ShoppingCartContext } from 'src/components/report/ShoppingCartContext';

export const CLEAR_CART_FIELD_TEST_ID = 'clear-cart-field';

interface ClearCartFieldProps {
  clearCart: () => void;
}
export const ClearCartFieldComponent: React.FC<ClearCartFieldProps> = ({
  clearCart,
}) => {
  const [toggleModal, setToggleModal] = useState(false);

  const handleToggleModal = () => {
    setToggleModal(!toggleModal);
  };
  const { t } = useTranslation('report');

  return (
    <Fragment>
      <ButtonPanel
        dataTestId={CLEAR_CART_FIELD_TEST_ID}
        onClick={handleToggleModal}
      >
        <DeleteRounded fontSize="large" />
        <span>{t('shoppingCart.clearAllReports')}</span>
      </ButtonPanel>

      <Modal
        headline={t('shoppingCart.clearAllReports')}
        isOpen={toggleModal}
        message={t('shoppingCart.clearReportsWarning')}
        onClose={handleToggleModal}
      >
        <DialogActions>
          <Button
            variant="cta"
            color="secondary"
            fullWidth
            onClick={handleToggleModal}
          >
            {t('common:cancel')}
          </Button>

          <Button
            variant="cta"
            fullWidth
            onClick={() => {
              clearCart();
              handleToggleModal();
            }}
          >
            {t('shoppingCart.clearReports')}
          </Button>
        </DialogActions>
      </Modal>
    </Fragment>
  );
};

const ClearCartFieldWrapper: React.FC = (props) => (
  <ShoppingCartContext.Consumer>
    {({ clearCart }) => (
      <ClearCartFieldComponent clearCart={clearCart} {...props} />
    )}
  </ShoppingCartContext.Consumer>
);

export default ClearCartFieldWrapper;
